import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import DocumentTypeIcon from '@/components/document-type-icon.vue';
import { useTelemetry } from '@/plugins/telemetry';
export default defineComponent({
  components: {
    DocumentTypeIcon: DocumentTypeIcon
  },
  props: {
    reference: {
      type: Object,
      required: true
    },
    selectedReference: {
      type: Object,
      default: null
    },
    handleSelectReference: {
      type: Function,
      required: true
    },
    references: {
      type: [Array, Object],
      required: true
    },
    showDetailedReference: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props) {
    var telemetry = useTelemetry();
    var route = useRoute();
    var handleClick = function handleClick(ref) {
      props.handleSelectReference(_objectSpread(_objectSpread({}, ref), {}, {
        focus: true,
        scroll: true,
        type: type.value
      }));
      telemetry.sendClickTelemetry({
        button: 'holmes__reference',
        params: {
          targetId: props.references[ref.document].record.id,
          documentIndex: ref.document,
          sectionIndex: ref.section
        }
      }, route);
    };
    var type = computed(function () {
      var _props$references$pro;
      return (_props$references$pro = props.references[props.reference.document].record.type) !== null && _props$references$pro !== void 0 ? _props$references$pro : 'book';
    });
    return {
      handleClick: handleClick,
      type: type
    };
  }
});